import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateEstimateRequest } from '../../types/estimate.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

/**
 * Nouvelle demande depuis l'espace client. Même corps que l'endpoint public,
 * mais le devis est rattaché au compte et non à l'email saisi.
 */
export const useCreateMyEstimateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: CreateEstimateRequest) => {
      const response = await apiClient.client.post('/me/estimates', request)
      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: meKeys.estimates })
    },
  })
}
